<div *ngIf="global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
    <div class="row mb-2">
        <div class="col pl-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">

    <div class="col-12">
        <h4 class="mb-2 font-header-1">Client</h4>
    </div>
    <div class="col-12 mt-3 p-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-body transparent">
                <div class="row mb-2 d-flex justify-content-center align-items-center">
                    <div class="col-lg-2 col-md-2 col-sm-6">
                        <button type="button" class="btn btn-sm" (click)="AddClient('new')" *ngIf="fp.clientcreate">
                            Add Client
                        </button>
                    </div>
                    
                    <div class="col-lg-4 col-md-5 col-sm-6 d-inline-flex justify-content-center mt-2 pt-1">
                        <input type="text" placeholder="Client name" [(ngModel)]="getClient.value"
                            (keyup.enter)="getClientListDetails()"
                            [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null||global.globalAgencyId==''"
                            class="form-control element_width2">

                        <i class="bi bi-search py-1 fs-5 iconSearch" id="button-addon2" (click)="getClientListDetails()"
                            style="margin-left:-20px;"></i>

                    </div>
                    <div class="col-lg-3 col-md-5 col-sm-6">
                        <label>Show Client&nbsp;</label>

                        <ng-select class="w-70" [(ngModel)]="getClient.statusLId" (change)="getClientListDetails()"
                            style="color: black;width:65%;" [clearable]="false" [searchable]="true" [items]="statusList"
                            bindLabel="lovName" bindValue="id">

                        </ng-select>
                    </div>
                    <div class="col-lg-3  col-md-12 col-sm-6 d-flex justify-content-lg-end">
                         <button class="btn  btn-sm me-2" type="button" data-bs-target="#EligibilityInfo" id="ClientListISEDI271Client"
                data-bs-toggle="modal" (click)="openEligibility()">Eligibility</button> 
                        <button class="btn  btn-sm me-2" type="button" (click)="exportCsv()">ExportCSV</button>

                        <button class="btn  btn-sm " type="button" (click)="Refresh()"><i
                                class="fa fa-repeat">&nbsp;</i>Refresh</button>
                    </div>
                </div>
                <!--================================== Client Ejs Grid================================================================-->
                <div class="row mt-2 pt-1">
                    <div class="col-12">
                        <ejs-grid #grid id='grid' [dataSource]='data|async' [allowResizing]='true' [allowSorting]='true'
                            allowPaging='true' [allowFiltering]='true' (dataStateChange)='dataChangeClient($event)'
                            (actionBegin)="onActionClient($event)" [pageSettings]='initialPage'
                            [filterSettings]='filterSettings' [showColumnChooser]='true'>

                            <e-columns>
                                <e-column width=100 uid="action" headerText="Actions" [showInColumnChooser]='false'>
                                    <ng-template #template let-data>
                                        <button class="btn btn-reset-table" data-bs-toggle="modal"
                                            ngbTooltip="Reset Password" *ngIf="fp.clientkeyupdate"
                                            data-bs-target="#Reset_ConfirmationClient" (click)="resetpassword(data);"><i
                                                class="fa fa-key" aria-hidden="true"></i></button> &nbsp;
                                        <button class="btn btn-edit-table"
                                            (click)="Clientdatatobind(data);AddClient('edit');" *ngIf="fp.clientupdate">
                                            <i class="fa fa-edit"></i></button>&nbsp;

                                    </ng-template>
                                </e-column>
                                <e-column width=150 field="name" headerText="Name" type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="medicaid" headerText="Medicaid" type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="insuranceNo" headerText="Client Insurance ID"
                                    type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=130 field="qPname" headerText="QP Name" type='string' [allowFiltering]="false" [allowSorting]="false">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="primaryPhysician" headerText="Primary Physician" [allowFiltering]="false" [allowSorting]="false"
                                    type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=80 field="dob" headerText="DOB" type='date'
                                    [format]='formatOptions'>
                                </e-column>
                                <e-column width=80 field="age" headerText="Age" type='number' (keypress)="numberOnly($event)" >
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value" mask="000"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=130 field="email" headerText="Email" type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=120 field="lastEligibility" headerText="Last Eligibility" [allowFiltering]="false" [allowSorting]="false"
                                    type='datetime' [format]='formatOptions'></e-column>
                                <e-column minWidth=100 field="isMAEligible" headerText="MA Eligible" type='boolean' [allowSorting]="false" [displayAsCheckBox]='false'>
                                    <ng-template #template let-data>
                                        {{data.isMAEligible === 'true' || data.isMAEligible === true ? 'true' : 'false'}}
                                    </ng-template>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-dropdownlist placeholder='Select' [dataSource]='[{text: "true", value: "true"}, {text: "false", value: "false"}]'
                                            [fields]='{text: "text", value: "value"}'>
                                        </ejs-dropdownlist>
                                    </ng-template>
                                </e-column>

                                <e-column minWidth=100 field="locationName" type='string' headerText="Location">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="phone1" headerText="Phone" type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=80 field="street" headerText="Street" type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=80 field="zipCode" headerText="ZIP Code" type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="status_Name" headerText="Status" type='number'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=80 field="paySource" headerText="Pay Source" type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="programType"  headerText="Program Type"  type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="languages" headerText="Languages" type='string'>
                                    <ng-template #filterTemplate let-data>

                                    </ng-template>
                                </e-column>
                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div>
                                            <span id='show' (click)='show()'><i class="fa fa-cog fa-lg"
                                                    aria-hidden="true">
                                                </i></span>
                                        </div>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="modal fade " id="Reset_ConfirmationClient" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">

    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Reset Password</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                Do you want to reset your password?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal"
                    (click)="changeClientPortalPass()">Yes</button>
                <button type="button" class="btn btn-sm" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>

<!-- EligibilityInfo -->
<span id="EligibilityOpen" data-bs-toggle="modal" data-bs-target="#EligibilityInfo"></span>
<div class="modal hide fade modalbackgrod supreme-container" id="EligibilityInfo" tabindex="-1"
  aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog mw-100" role="document">
    <div class="modal-content">
      <div class="modal-header modal-header1 border-0">
        <h5 class="modal-title text-left font-header">Eligibility Report</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeEligiblity()" id="ClientListcloseEligiblityicon"></button>
      </div>
      <div class="modal-body modal-body1">
        <app-eligibility-report *ngIf="ISEDI271Client" >
        </app-eligibility-report>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" (click)="closeEligiblity()" id="ClientListcloseEligiblitybtn">Close</button>
      </div>
    </div>
  </div>
</div>